export enum TIME_FORMAT {
    TWENTY_FOUR = 24,
    TWELVE = 12,
  }